import {
  isUsingSupportedBrowser,
  getDomainName,
  getBrowser,
  getOS
} from './browser'
import { getCookie, getCookies, setCookie } from './cookie'
import { getQueryString } from './location'

export default {
  getCookie,
  getCookies,
  getDomainName,
  getQueryString,
  setCookie,
  isUsingSupportedBrowser,
  getBrowser,
  getOS
}
